<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>cashback.search</h3>
        </span>
    </div>

    <div class="my-2 py-2" *ngIf="loadSearchForm$ | async as data; else loading">
        <!-- ****************************************************** 
        ************** Search Form *************
        ****************************************************** -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- service type -->
                <div class="input-group-prepend">
                    <span class="input-group-text" translate>cashback.serviceType</span>
                </div>
                <select class="custom-select input-custom-size" [compareWith]="compareById" formControlName="serviceType" (change)="onServiceTypeChange($event)">
                    <option value="" [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let serviceType of serviceTypes" [ngValue]="serviceType"> {{serviceType.description}}
                </select>
                
                <!-- service -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>cashback.service</span>
                </div>
                <select class="custom-select input-custom-size" [compareWith]="compareById" formControlName="service">
                    <option value="" [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let service of filteredServices" [ngValue]="service"> {{service.name}}
                </select>
                
                <!-- status  -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>cashback.status</span>
                </div>
                <select class="custom-select input-custom-size" [compareWith]="compareById" formControlName="status">
                    <option value="" [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let status of statuses" [ngValue]="status"> {{status.name}}
                </select>

                <ng-container>
                    <!-- actions -->
                    <div class="input-group-prepend ml-2">
                        <div style="display: flex;">
                            <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                            <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                            <button class="btn btn-outline-success ml-2" style="border-radius: 0;" routerLink="/add-edit-cashback"
                                type="button" *ngIf="canAddEdit" translate>button.add</button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
        <br>
        <!-- ****************************************************** 
        ************** Table Data *************
        ****************************************************** -->
        <div class=" d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th translate>cashback.service</th>
                        <th translate>cashback.moneyValueOfPoint</th>
                        <th translate>cashback.priceAttributeKind</th>
                        <th translate>cashback.amount</th>
                        <th sortBy="status" (sort)="onSort($event)" translate>cashback.status</th>
                        <th translate>cashback.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cashback of content">
                        <td>{{cashback.serviceName}}</td>
                        <td>{{cashback.moneyValueOfPoint}}</td>
                        <td>{{cashback.priceAttributeKind === 'V' ? 'Стойност' : cashback.priceAttributeKind === 'P' ? 'Процент' : cashback.priceAttributeKind}}</td>
                        <td>{{cashback.priceAttributeAmountDds != null ? cashback.priceAttributeAmountDds : cashback.priceAttributeAmount}}</td>
                        <td>{{cashback.status.name}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" routerLink="/add-edit-cashback" *ngIf="canView"
                            data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}" 
                            [queryParams]="{id: cashback.id}"><i class="fa fa-pencil fa-lg"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
        <!-- ****************************************************** 
        ************** Pagination *************
        ****************************************************** -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}} 
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #loading>
    <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #spinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>

<ng-template #dataLoadingTemplate>
        <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #dataSpinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
</ng-template>